/**
 * Sell Your Car page SEO (Milestone 1).
 */
import { buildBreadcrumbJsonLd, combineStructuredData } from "./structuredData";
import { AUTOMAPA_DEFAULT_OG_IMAGE } from "./seoConstants";
import { buildMetaDescription, buildPageTitle, buildSeoBundle } from "./seoUtils";
import { SELL_YOUR_CAR_PATH } from "../constants/sellYourCarPageConstants";

export function getSellYourCarSeo() {
  const bundle = buildSeoBundle({
    title: buildPageTitle("Vende tu carro en AutoMapa"),
    description: buildMetaDescription(
      "Envía la información de tu vehículo para revisión y prepara una publicación clara en AutoMapa."
    ),
    canonicalPath: SELL_YOUR_CAR_PATH,
    robots: "index, follow",
    image: AUTOMAPA_DEFAULT_OG_IMAGE,
  });

  const breadcrumbs = [
    { label: "Inicio", href: "/" },
    { label: "Vender mi carro", href: SELL_YOUR_CAR_PATH },
  ];

  return {
    ...bundle,
    breadcrumbs,
    structuredData: combineStructuredData(buildBreadcrumbJsonLd(breadcrumbs)),
  };
}
